class {
  onCreate() {
    this.state = {
      expandedItems: {},
      currentLang: 'en',
      faqTranslations: {
        'en': {
          title: 'Frequently Asked Questions',
          items: [
            {
              question: "Who should use Plixi?",
              answer: "Plixi is for anyone who wants to grow their Instagram account organically. Whether you're a business, influencer, or just someone who wants to grow their personal account, Plixi is the best Instagram growth service for you."
            },
            {
              question: "What is required to use Plixi?",
              answer: "All you need is an Instagram account. You can use Plixi on your personal account, business account, or even an influencer account. You can also use Plixi on multiple accounts at once."
            },
            {
              question: "How many followers can I get with Plixi?",
              answer: "At least 1000 followers per month. Plixi is designed to help you grow your account organically. We don't use bots or fake accounts to grow your account. Instead, we use a combination of organic growth strategies to help you grow your account naturally."
            }
          ]
        },
        'es': {
          title: 'Preguntas Frecuentes',
          items: [
            {
              question: "¿Quién debería usar Plixi?",
              answer: "Plixi es para cualquier persona que quiera hacer crecer su cuenta de Instagram de forma orgánica. Ya seas una empresa, influencer o simplemente alguien que quiera hacer crecer su cuenta personal, Plixi es el mejor servicio de crecimiento de Instagram para ti."
            },
            {
              question: "¿Qué se necesita para usar Plixi?",
              answer: "Solo necesitas una cuenta de Instagram. Puedes usar Plixi en tu cuenta personal, cuenta de negocios o incluso en una cuenta de influencer. También puedes usar Plixi en múltiples cuentas a la vez."
            },
            {
              question: "¿Cuántos seguidores puedo conseguir con Plixi?",
              answer: "Al menos 1000 seguidores por mes. Plixi está diseñado para ayudarte a hacer crecer tu cuenta de forma orgánica. No usamos bots ni cuentas falsas para hacer crecer tu cuenta. En cambio, usamos una combinación de estrategias de crecimiento orgánico para ayudarte a crecer tu cuenta de forma natural."
            }
          ]
        },
        'fr': {
          title: 'Questions Fréquemment Posées',
          items: [
            {
              question: "Qui devrait utiliser Plixi?",
              answer: "Plixi est pour tous ceux qui veulent faire croître leur compte Instagram de manière organique. Que vous soyez une entreprise, un influenceur ou simplement quelqu un qui veut faire croître son compte personnel, Plixi est le meilleur service de croissance Instagram pour vous."
            },
            {
              question: "Que faut-il pour utiliser Plixi?",
              answer: "Tout ce dont vous avez besoin est un compte Instagram. Vous pouvez utiliser Plixi sur votre compte personnel, compte professionnel ou même un compte d influenceur. Vous pouvez également utiliser Plixi sur plusieurs comptes à la fois."
            },
            {
              question: "Combien de followers puis-je obtenir avec Plixi?",
              answer: "Au moins 1000 followers par mois. Plixi est conçu pour vous aider à faire croître votre compte de manière organique. Nous n utilisons pas de bots ou de faux comptes pour faire croître votre compte. Au lieu de cela, nous utilisons une combinaison de stratégies de croissance organique pour vous aider à faire croître votre compte naturellement."
            }
          ]
        },
        'de': {
          title: 'Häufig Gestellte Fragen',
          items: [
            {
              question: "Wer sollte Plixi nutzen?",
              answer: "Plixi ist für jeden, der sein Instagram-Konto organisch wachsen lassen möchte. Ob Sie ein Unternehmen, Influencer oder einfach jemand sind, der sein persönliches Konto wachsen lassen möchte, Plixi ist der beste Instagram-Wachstumsdienst für Sie."
            },
            {
              question: "Was wird benötigt, um Plixi zu nutzen?",
              answer: "Alles, was Sie brauchen, ist ein Instagram-Konto. Sie können Plixi auf Ihrem persönlichen Konto, Geschäftskonto oder sogar einem Influencer-Konto verwenden. Sie können Plixi auch auf mehreren Konten gleichzeitig verwenden."
            },
            {
              question: "Wie viele Follower kann ich mit Plixi bekommen?",
              answer: "Mindestens 1000 Follower pro Monat. Plixi ist darauf ausgelegt, Ihnen zu helfen, Ihr Konto organisch zu wachsen. Wir verwenden keine Bots oder gefälschte Konten, um Ihr Konto zu vergrößern. Stattdessen verwenden wir eine Kombination aus organischen Wachstumsstrategien, um Ihnen zu helfen, Ihr Konto auf natürliche Weise zu vergrößern."
            }
          ]
        },
        'it': {
          title: 'Domande Frequenti',
          items: [
            {
              question: "Chi dovrebbe usare Plixi?",
              answer: "Plixi è per chiunque voglia far crescere il proprio account Instagram in modo organico. Che tu sia un'azienda, un influencer o semplicemente qualcuno che vuole far crescere il proprio account personale, Plixi è il miglior servizio di crescita Instagram per te."
            },
            {
              question: "Cosa serve per usare Plixi?",
              answer: "Tutto ciò di cui hai bisogno è un account Instagram. Puoi usare Plixi sul tuo account personale, account aziendale o anche su un account influencer. Puoi anche usare Plixi su più account contemporaneamente."
            },
            {
              question: "Quanti follower posso ottenere con Plixi?",
              answer: "Almeno 1000 follower al mese. Plixi è progettato per aiutarti a far crescere il tuo account in modo organico. Non utilizziamo bot o account falsi per far crescere il tuo account. Invece, utilizziamo una combinazione di strategie di crescita organica per aiutarti a far crescere il tuo account in modo naturale."
            }
          ]
        },
        'pt': {
          title: 'Perguntas Frequentes',
          items: [
            {
              question: "Quem deve usar o Plixi?",
              answer: "O Plixi é para qualquer pessoa que queira crescer sua conta do Instagram de forma orgânica. Seja você uma empresa, influenciador ou apenas alguém que quer crescer sua conta pessoal, o Plixi é o melhor serviço de crescimento do Instagram para você."
            },
            {
              question: "O que é necessário para usar o Plixi?",
              answer: "Tudo o que você precisa é de uma conta do Instagram. Você pode usar o Plixi em sua conta pessoal, conta comercial ou até mesmo em uma conta de influenciador. Você também pode usar o Plixi em várias contas ao mesmo tempo."
            },
            {
              question: "Quantos seguidores posso conseguir com o Plixi?",
              answer: "Pelo menos 1000 seguidores por mês. O Plixi é projetado para ajudá-lo a crescer sua conta de forma orgânica. Não usamos bots ou contas falsas para crescer sua conta. Em vez disso, usamos uma combinação de estratégias de crescimento orgânico para ajudá-lo a crescer sua conta naturalmente."
            }
          ]
        },
        'ko': {
          title: '자주 묻는 질문',
          items: [
            {
              question: "누가 Plixi를 사용해야 하나요?",
              answer: "Plixi는 Instagram 계정을 유기적으로 성장시키고 싶은 모든 사람을 위한 것입니다. 비즈니스, 인플루언서 또는 개인 계정을 성장시키고 싶은 사람이든, Plixi는 당신을 위한 최고의 Instagram 성장 서비스입니다."
            },
            {
              question: "Plixi를 사용하려면 무엇이 필요한가요?",
              answer: "Instagram 계정만 있으면 됩니다. 개인 계정, 비즈니스 계정 또는 인플루언서 계정에서 Plixi를 사용할 수 있습니다. 여러 계정에서 동시에 Plixi를 사용할 수도 있습니다."
            },
            {
              question: "Plixi로 몇 명의 팔로워를 얻을 수 있나요?",
              answer: "월 최소 1000명의 팔로워. Plixi는 계정을 유기적으로 성장시키는 데 도움을 주도록 설계되었습니다. 계정을 성장시키기 위해 봇이나 가짜 계정을 사용하지 않습니다. 대신, 유기적 성장 전략의 조합을 사용하여 자연스럽게 계정을 성장시키는 데 도움을 줍니다."
            }
          ]
        },
        'ar': {
          title: 'الأسئلة الشائعة',
          items: [
            {
              question: "من يجب أن يستخدم Plixi؟",
              answer: "Plixi مخصص لأي شخص يريد تنمية حسابه على Instagram بشكل عضوي. سواء كنت شركة أو مؤثرًا أو مجرد شخص يريد تنمية حسابه الشخصي، فإن Plixi هو أفضل خدمة نمو Instagram لك."
            },
            {
              question: "ما المطلوب لاستخدام Plixi؟",
              answer: "كل ما تحتاجه هو حساب Instagram. يمكنك استخدام Plixi على حسابك الشخصي أو حساب الأعمال أو حتى حساب المؤثرين. يمكنك أيضًا استخدام Plixi على حسابات متعددة في وقت واحد."
            },
            {
              question: "كم عدد المتابعين الذين يمكنني الحصول عليهم مع Plixi؟",
              answer: "على الأقل 1000 متابع شهريًا. تم تصميم Plixi لمساعدتك على تنمية حسابك بشكل عضوي. نحن لا نستخدم الروبوتات أو الحسابات المزيفة لتنمية حسابك. بدلاً من ذلك، نستخدم مزيجًا من استراتيجيات النمو العضوي لمساعدتك على تنمية حسابك بشكل طبيعي."
            }
          ]
        },
        'pl': {
          title: 'Często Zadawane Pytania',
          items: [
            {
              question: "Kto powinien używać Plixi?",
              answer: "Plixi jest dla każdego, kto chce organicznie rozwijać swoje konto na Instagramie. Niezależnie od tego, czy jesteś firmą, influencerem, czy po prostu kimś, kto chce rozwijać swoje osobiste konto, Plixi jest najlepszą usługą wzrostu na Instagramie dla Ciebie."
            },
            {
              question: "Co jest wymagane do korzystania z Plixi?",
              answer: "Wszystko, czego potrzebujesz, to konto na Instagramie. Możesz używać Plixi na swoim koncie osobistym, koncie firmowym, a nawet koncie influencera. Możesz także używać Plixi na wielu kontach jednocześnie."
            },
            {
              question: "Ilu obserwujących mogę zdobyć dzięki Plixi?",
              answer: "Co najmniej 1000 obserwujących miesięcznie. Plixi jest zaprojektowany, aby pomóc Ci organicznie rozwijać Twoje konto. Nie używamy botów ani fałszywych kont do rozwijania Twojego konta. Zamiast tego używamy kombinacji strategii organicznego wzrostu, aby pomóc Ci naturalnie rozwijać Twoje konto."
            }
          ]
        }
      }
    };
  }

  onMount() {
    // Get initial language
    this.updateLanguage();
    
    // Listen for Weglot language changes
    if (typeof Weglot !== 'undefined' && Weglot.on) {
      Weglot.on('languageChanged', (newLang) => {
        this.updateLanguage(newLang);
      });
    } else {
      window.addEventListener('load', () => {
        if (typeof Weglot !== 'undefined') {
          this.updateLanguage();
          if (Weglot.on) {
            Weglot.on('languageChanged', (newLang) => {
              this.updateLanguage(newLang);
            });
          }
        }
      });
    }
  }

  updateLanguage(lang) {
    let currentLang = lang;
    if (!currentLang && typeof Weglot !== 'undefined' && Weglot.getCurrentLang) {
      currentLang = Weglot.getCurrentLang();
    }
    if (!currentLang) {
      currentLang = 'en';
    }
    // Fallback to English if language not supported
    if (!this.state.faqTranslations[currentLang]) {
      currentLang = 'en';
    }
    this.state.currentLang = currentLang;
  }

  getCurrentFaq() {
    return this.state.faqTranslations[this.state.currentLang] || this.state.faqTranslations['en'];
  }

  toggleItem(itemId) {
    this.state.expandedItems = {
      ...this.state.expandedItems,
      [itemId]: !this.state.expandedItems[itemId]
    };
  }
}

$ const currentFaq = component.getCurrentFaq();

<div class="faq-accordion section flex justify-center py-0 mt-64 mb-12 md-max:mt-64">
  <div class="faq-container faq">
    <h2 class="faq-title xl bold before-enter enter text-center" style="line-height: unset;">${currentFaq.title}</h2>
    
    <div class="faq-items before-enter enter">
      <for|item, index| of=currentFaq.items>
        <div class="faq-item">
          <div 
            class=["faq-question", state.expandedItems[`item-${index}`] && "active"]
            onClick("toggleItem", `item-${index}`)
          >
            <span>
              <i class="fa fa-solid fa-chevron-down"></i>
              ${item.question}
            </span>
          </div>
          <div class=["faq-answer", state.expandedItems[`item-${index}`] && "expanded"]>
            <p>${item.answer}</p>
          </div>
        </div>
      </for>
    </div>

    <div itemscope="itemscope" itemtype="https://schema.org/FAQPage" class="hide-faq">
      <for|item, index| of=currentFaq.items>
        <div itemscope="itemscope" itemprop="mainEntity" itemtype="https://schema.org/Question">
          <h3 itemprop="name">${item.question}</h3>
          <div itemscope="itemscope" itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              ${item.answer}
            </div>
          </div>
        </div>
      </for>
    </div>
  </div>
</div>

<!-- FAQ Styling -->
<style>
    .hide-faq {
      display: none;
    }
    .faq-accordion {
      border-top: 1px solid #E7EBEF;
      max-width: 800px;
      margin: 0 auto;
    }
    .faq {
      padding-top: 50px;
    }
    .faq-title {
      margin-bottom: 2rem;
      text-align: center;
    }
    .faq-items {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .faq-item {
      border-bottom: 1px solid #0E151B;
    }
    .faq h2, .faq-content-left {
      text-align: left;
    }
    .faq-container.faq h2.enter {
      font-family: CeraPro,sans-serif;
      line-height: 90px;
      font-size: 20px;
      font-weight: 700;
    }           
    .faq-content-first {
      color: #858d96;
      padding-top: 50px;
    }           
    .faq-content-second {
      font-size: 24px;
      margin-top: 5px;
    }           
    .faq-content-svg {
      display: flex;
    }           
    .faq-question i.fas.fa-chevron-down {
      vertical-align: middle;
      margin-right: 15px;
      transition: transform 0.3s ease;
    }
    .faq-question i.fas.fa-chevron-down.rotated {
      transform: rotate(180deg);
    }
    .faq-body-search {
      align-items: center;
      display: flex;
      margin-bottom: 2px;
      position: relative;
    }           
    .faq-body-more {
      align-items: center;
      color: #858d96;
      cursor: pointer;
      display: flex;
      font-size: 18px;
      margin-top: 20px;
      padding: 20px 0;
    }           
    @media (max-width: 991px) {
      .faq {
        flex-direction: column;
      }           
      .faq-content {
        column-gap: 40px;
        display: grid;
        grid-template-columns: 1fr;
      }           
      .faq-content-svg {
        justify-content: center;
      }           
      .faq-content-left {
        text-align: center;
      }
      .faq-container.faq h2.enter {
        line-height: 55px;
        font-size: 16px;
      }           
      .faq-spacer {
        display: none;
      }
    }           
    .faq-container {
      margin-left: auto;
      margin-right: auto;
      padding-left: 15px;
      padding-right: 15px;
    }    
    @media (max-width: 500px) {
      .faq-container {
        margin-left: 0;
        padding-left: 0;
        padding-right:0;
        margin-right:0;
      }
    }       
    @media (min-width: 768px) {
      .faq-container {
        width: 750px;
      }
    .faq-accordion{
      border-top: 0px;
    }
    .faq{
      padding-top: 0px;
    }
    .faq-question>span{
      font-size:14px;
    }

    }           
    @media (min-width: 992px) {
      .faq-container {
        width: 970px;
      }
    }           
    @media (min-width: 1200px) {
      .faq-container {
        width: 1170px;
      }
    }           
    .before-enter {
      /* transition: all 1.5s; */
    }           
    .enter {
      opacity: 1;
      transform: translateY(0);
    }           
    .faq h2 {
      max-width: 700px;
    }           
    .faq-content-svg a {
      cursor: pointer;
    }           
    .faq-content-svg-arrow svg {
      font-size: 90px;
      transform: rotate(250deg);
    }           
    .faq-body-search svg {
      font-size: 28px;
      position: absolute;
    }           
    .faq-body-search input {
      appearance: none;
      background-color: transparent;
      border-bottom: 1px dashed #858d96;
      border-radius: 0;
      border-style: dashed;
      font-size: 18px;
      font-weight: 300;
      padding: 20px 65px 20px 44px;
      width: 50%;
    }           
    .faq-body-more svg {
      font-size: 24px;
      margin-left: 10px;
    }           
    .faq-body ul {
      width: 100%;
      justify-content: left;
      line-height: 27px;
      text-align: left;
      margin-top: 15px;
    }           
    @media (max-width: 991px) {
      .faq h2 {
        text-align: center;
      }           
      .faq-body input {
        font-size: 20px;
        padding: 20px 20px 20px 44px;
        width: 100%;
      }
    }           
    .faq-content-svg a svg {
      margin-top: 30px;
    }           
    .faq-body ul li {
      border-bottom: 1px solid #0E151B;
      cursor: pointer;
      position: relative;
      z-index: 0;
    }           
    .faq-body-more:hover {
      color: #000;
    }           
    .faq-body-search input:focus {
      border-bottom: 1px solid #000;
      outline: 0;
    }           
    .faq-question {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: 13px 0;
      font-size: 16px;
      font-weight: 500;
      font-family: Cera Pro,sans-serif;
      color: #0E151B;
    }
    .faq-question.active {
      color: #0E151B;
    }
    .faq-question i.fa-chevron-down {
      vertical-align: middle;
      margin-right: 15px;
      transition: transform 0.3s ease;
    }
    .faq-question.active i.fa-chevron-down {
      transform: rotate(180deg);
    }
    .faq-answer {
      height: 0;
      pointer-events: none;
      opacity: 0;
      padding: 0 30px;
      overflow: hidden;
      transition: all 0.3s ease;
    }
    .faq-answer.expanded {
      height: auto;
      opacity: 1;
      padding: 0 0 30px;
      pointer-events: all;
    }
    .faq-answer p {
      line-height: 1.5;
      font-size: 16px;
      color: #86939E
    }           
    .faq-body ul .faq-answer b {
      font-weight: 600;
    }           
    .faq-body ul .faq-answer a {
      color: #3279f7;
      font-weight: 500;
    }           
    .faq-body ul .faq-question label svg {
      display: inline-block;
      color: #0E151B;
      font-size: 14px;
      margin-right: 20px;
    }
    .faq-question>span{
      font-size:16px;
    }
    .faq-body ul .faq-answer a:hover {
      text-decoration: underline;
    }
    .contact_footer + div{
      /* display:none; */
    }
  </style>